import React from 'react';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';

const EligibleCardComponent = ({ card }) => {
  const shouldRenderCard = card !== null;

  if (!shouldRenderCard) return null;
  //if car should be renedered get the values
  const shouldRenderImage = !!card?.fields?.image;
  const shouldRenderTitle = !!card?.fields?.heading;
  const shouldRenderLink = !!card?.url && card?.url !== '';

  return (
    <div className="eligible-card-item">
      {shouldRenderImage && (
        <figure>
          <Image field={card?.fields?.image} />
        </figure>
      )}
      {shouldRenderTitle && (
        <div className="arrow-title">
          <img
            className="arrow"
            src={'/-/jssmedia/Project/FAB2/shared/images/eligibleCardsArrowRight.svg'}
          />
          <RichText className="title" field={card?.fields?.heading} />
        </div>
      )}
      {shouldRenderLink && <a className="link" href={card?.url}></a>}
    </div>
  );
};

export default EligibleCardComponent;
